import { useEffect } from 'react';
import { useReports } from 'services/assist-api/entities/reports/reports';

export const useManageReportDocumentTitle = (reportIdentifier: string | undefined): void => {
  const reportName = useReports({ filters: { identifier: reportIdentifier } }).data?.json[0]?.name;

  // restore tab title
  useEffect(() => {
    const docTitle = document.title;
    return () => {
      document.title = docTitle;
    };
  }, []);

  // update tab title
  useEffect(() => {
    if (reportName) {
      document.title = `Assist - ${reportName}`;
    }
  }, [reportName]);
};
